// extracted by mini-css-extract-plugin
export default {"coordinatorsec":"coordinatorsec_coordinatorsec__ddlvQ","co_container":"coordinatorsec_co_container__O52+B","ov_container":"coordinatorsec_ov_container__lJxj6"};